import { HStack, Text, Heading, VStack, Icon } from '@chakra-ui/react';
import ContentContainer from '~/containers/Content';
import { IoCloseCircle } from 'react-icons/io5';
import { IoMdArrowRoundForward } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

// 歸還餐盒推廣提醒
export default function FooterReturnNotice() {
  const navigate = useNavigate();

  const [isShow, setIsShow] = useState<boolean>();

  const handleOnClickCloseBtn = () => {
    setIsShow(false);
  };

  useEffect(() => {
    window.addEventListener('load', (event) => {
      setIsShow(true);
    });
  }, [window]);

  return (
    <>
      {isShow && (
        <ContentContainer transition="0.3s">
          <VStack zIndex={1} pos="relative" bg="#F7EFE3" w="full" borderTopRadius="20px" p={6}>
            <Icon
              as={IoCloseCircle}
              color="primary"
              pos="absolute"
              boxSize="1.75rem"
              top={2}
              right={2}
              _hover={{
                cursor: 'pointer',
              }}
              onClick={handleOnClickCloseBtn}
            />

            <Heading size="xs" color="secondary">
              歡迎加入環保餐盒點餐行列！
            </Heading>
            <VStack spacing={0}>
              <Text fontSize="sm" color="secondary">
                食用完餐點後，定點歸還餐盒
              </Text>
              <Text fontSize="sm" color="secondary">
                享受美食的同時也一起做環保
              </Text>
            </VStack>
            <HStack
              p={2}
              bg="primary"
              borderRadius="5px"
              spacing={1}
              as="button"
              onClick={() => navigate('/mealBoxRecycling')}
            >
              <Text color="#F7EFE3" fontSize="xs" fontWeight="bold">
                哪裡可以歸還餐盒
              </Text>
              <Icon as={IoMdArrowRoundForward} color="#F7EFE3" />
            </HStack>
          </VStack>
        </ContentContainer>
      )}
    </>
  );
}
